import {Text, TouchableWithoutFeedback, View, Image} from "react-native";
import {FontAwesome5} from "@expo/vector-icons";
import * as React from "react";
import {SectionTitle} from "./section-title";

const ApplicationFeature = ({onPress, icon, title}) => <TouchableWithoutFeedback onPress={onPress}>
    <View style={{ height: 120, aspectRatio: 1, backgroundColor: "white", borderRadius: 30, alignItems: "center", justifyContent: "space-evenly" }}>
        <Image source={icon} />
        <Text style={{fontWeight: "bold", fontSize: 12, color: "#a0c946"}}>{title}</Text>
    </View>
</TouchableWithoutFeedback>

export function ApplicationFeatures({goPickupService}) {
    return <>
        <SectionTitle>Our services</SectionTitle>
        <View style={{justifyContent: "space-around", marginTop: 5, flexDirection: "row"}}>
            <ApplicationFeature title="Ask pick up" icon={require('../../../../assets/images/home/icon-services-car.png')} onPress={goPickupService} />
            <ApplicationFeature title="Additional Bin(s)" icon={require('../../../../assets/images/home/icon-services-bin.png')} onPress={goPickupService} />
        </View>
    </>;
}